import type { IconName } from '@core/user-interface-legacy';

import type { DowngradeViewTextsI } from './product-order-downgrade.types';

export const DowngradeViewTexts: DowngradeViewTextsI = {
  accordionHeading: 'app.pricing.product_order.downgrade.what_happens_to_the_scale',
  trialConfirmCheckbox: 'app.pricing.product_order.downgrade.trial_confirmation',
  features: [
    {
      title: 'app.pricing.product_order.downgrade.missing_features.aa_and_triggers',
      link: 'app.support_resources.automated_actions',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.custom_careers_url',
      link: 'app.support_resources.custom_domain',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.send_later',
      link: 'app.support_resources.schedule_emails_to_be_sent_later',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.roles',
      link: 'app.support_resources.roles',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.schedulers',
      description: 'app.pricing.product_order.downgrade.missing_features_descriptions.schedulers',
      link: 'app.support_resources.schedule_events',
      items: [
        {
          title: 'app.pricing.product_order.downgrade.missing_features.schedulers',
          link: 'app.support_resources.schedule_events',
        },
        {
          title: 'app.common.and',
        },
        {
          title: 'app.pricing.product_order.downgrade.missing_features.jobs',
          link: 'app.support_resources.job_scheduler',
        },
      ],
    },

    {
      title: 'app.pricing.product_order.downgrade.missing_features.multilang',
      link: 'app.support_resources.multilang',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.knockout_questions',
      link: 'app.support_resources.knockout_questions',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.templates',
      description: 'app.pricing.product_order.downgrade.missing_features_descriptions.templates',
      link: 'app.support_resources.workflow_templates_collection',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.visibility',
      description: 'app.pricing.product_order.downgrade.missing_features_descriptions.visibility',
      link: 'app.support_resources.visibility',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.webhooks_access',
      link: 'app.support_resources.webhooks',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.advanced_reports',
      link: 'app.support_resources.reports_and_analysis',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.gdpr_eeo',
      link: 'app.support_resources.gdpr_collection',
      items: [
        {
          title: 'app.pricing.product_order.downgrade.missing_features.gdpr',
          link: 'app.support_resources.gdpr_collection',
        },
        {
          title: 'app.common.and',
        },
        {
          title: 'app.pricing.product_order.downgrade.missing_features.eeo',
          link: 'app.support_resources.eeo_collection',
        },
      ],
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.profile_print',
      link: 'app.support_resources.profile_print',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.careers_hub_multi_page',
      link: 'app.support_resources.multipage',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.fair_evaluations',
      link: 'app.support_resources.fair_evaluations',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.notifications_per_role',
      link: 'app.support_resources.notifications_per_role',
    },
    {
      title: 'app.pricing.product_order.downgrade.missing_features.locations',
      link: 'app.support_resources.manage_locations',
    },
  ],
  downgradedFeaturesLeft: [
    {
      icon: 'automated-actions',
      title: 'app.pricing.product_order.downgrade.features_info.aa_and_triggers.title',
      description: 'app.pricing.product_order.downgrade.features_info.aa_and_triggers.description',
    },
    {
      icon: 'dashboard',
      title: 'app.pricing.product_order.downgrade.features_info.templates.title',
      description: 'app.pricing.product_order.downgrade.features_info.templates.description',
    },
    {
      icon: 'block',
      title: 'app.pricing.product_order.downgrade.features_info.knockout_questions.title',
      description:
        'app.pricing.product_order.downgrade.features_info.knockout_questions.description',
    },
    {
      icon: 'location-city',
      title: 'app.pricing.product_order.downgrade.features_info.multilang.title',
      description: 'app.pricing.product_order.downgrade.features_info.multilang.description',
    },
    {
      icon: 'visibility-off',
      title: 'app.pricing.product_order.downgrade.features_info.hidden_evaluations.title',
      description:
        'app.pricing.product_order.downgrade.features_info.hidden_evaluations.description',
    },
  ],
  downgradedFeaturesRight: [
    {
      icon: 'remove-red-eye',
      title: 'app.pricing.product_order.downgrade.features_info.visibility.title',
      description: 'app.pricing.product_order.downgrade.features_info.visibility.description',
    },
    {
      icon: 'email',
      title: 'app.pricing.product_order.downgrade.features_info.schedulers.title',
      description: 'app.pricing.product_order.downgrade.features_info.schedulers.description',
    },
    {
      icon: 'person',
      title: 'app.pricing.product_order.downgrade.features_info.roles.title',
      description: 'app.pricing.product_order.downgrade.features_info.roles.description',
    },
    {
      icon: <IconName>'link',
      title: 'app.pricing.product_order.downgrade.features_info.custom_domain.title',
      description: 'app.pricing.product_order.downgrade.features_info.custom_domain.description',
      hideOnTrial: true,
    },
    {
      icon: 'library-add',
      title: 'app.pricing.product_order.downgrade.features_info.careers_hub_multi_page.title',
      description:
        'app.pricing.product_order.downgrade.features_info.careers_hub_multi_page.description',
    },
  ],
  heading: 'app.pricing.product_order.downgrade.missing_features_heading',
  headingTrial: 'app.pricing.product_order.downgrade.trial_missing_features_heading2',
  subheading: 'app.pricing.product_order.downgrade.missing_features_subheading',
  subheadingTrial: 'app.pricing.product_order.downgrade.trial_missing_features_subheading2',
  header: 'app.pricing.product_order.downgrade.title_downgrade_to_plan',
  headerTrial: 'app.pricing.product_order.downgrade.title_downgrade_to_plan_from_trial2',
};
